import { useState } from "react";
import { createPortal } from "react-dom";

function PendingModal({ title, testId, onClose, message = "pending" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={onClose} data-testid={`${testId}-overlay`}>
      <div className="w-full max-w-md p-8" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid={`${testId}-modal`}>
        <div className="flex justify-between items-start mb-6">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>{title}</span>
          <button onClick={onClose} data-testid={`${testId}-close`} className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
        </div>
        <p className="font-head text-base sm:text-lg leading-relaxed" style={{ color: "var(--text-primary)" }} data-testid={`${testId}-message`}>{message}</p>
      </div>
    </div>
  );
}

const FOUNDATION_TEXT = "a private non-profit organization that carries out charitable missions in person using 100% of the funds from the pot.";

export function FoundationLine() {
  const [open, setOpen] = useState(false);
  return (
    <p className="text-xs sm:text-sm tracking-widest text-center mb-6 fade-in" style={{ color: "var(--text-secondary)" }} data-testid="foundation-line">
      100% of proceeds go to{" "}
      <button onClick={() => setOpen(true)} data-testid="foundation-link" className="underline underline-offset-4 transition-opacity hover:opacity-80" style={{ color: "var(--accent)" }}>
        the mawilu foundation
      </button>
      {open && createPortal(<PendingModal title="the mawilu foundation" testId="foundation" message={FOUNDATION_TEXT} onClose={() => setOpen(false)} />, document.body)}
    </p>
  );
}

const ABOUT_TEXT = "this is mawilu, he is a real person and this is real live footage. Mawilu will not be leaving this room until the clock runs out. You can help him out or you can make things harder for him.";

export function AboutButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="about-btn" className="btn px-6 py-2 mb-6 text-xs tracking-widest">ABOUT</button>
      {open && createPortal(<PendingModal title="about" testId="about" message={ABOUT_TEXT} onClose={() => setOpen(false)} />, document.body)}
    </>
  );
}
